

















































import VueOptions from '@utils/VueOptions'
import FormFieldText from '@ui/FormBuilder/FormFields/FormFieldText'

settings =
  name: 'FormFieldContactSet'

  vue:
    props: ['value', 'errors']

    components: {
      FormFieldText,
    }

    data: ->
      defaultContactKeys = Object.keys(@value || {})
      defaultContactKeys.push 'main' unless 'main' in defaultContactKeys
      defaultContactKeys.push 'payment' unless 'payment' in defaultContactKeys
      value_ = @value unless @isEmptyValue(@value)
      value_ ||= { main: [{}], payment: [{}] }
      value_.main ||= [{}]
      value_.payment ||= [{}]

      value_: value_
      contactKeys: defaultContactKeys
      selectedContactKey: null

    computed:
      contacts: ->
        main:
          label: 'Main Contact'
          description: 'Primary person who people can reach out to'
        payment:
          label: 'Payment Contact'
          description: 'Person who can set up the bank account to receive payouts'
        sampling:
          label: 'Sampling Contact'
          description: 'Person who can manage handouts to attendees'
        shipment:
          label: 'Shipment Contact'
          description: 'Person who can receive, inspect and confirm shipments sent to you'

    methods:
      hiInputChange: ->
        @$emit 'input', @value_

      hiAddContact: ->
        @value_[@selectedContactKey] = [{}]
        @contactKeys.push @selectedContactKey
        @selectedContactKey = null

      hiRemoveContact: (contactKey, contactIndex) ->
        delete @value_[contactKey][contactIndex]
        @contactKeys.splice @contactKeys.indexOf(contactKey), 1
        @hiInputChange()

export default VueOptions.vue settings
